import PosthogService from '~/services/posthog/PosthogService';
import { UserProfession } from '~/enums/UserProfession';

// Event-specific interface (co-located)
export interface IPermPostJobSubmittedPayload {
  postingId: string;
  professionType: UserProfession;
  listingFee: string; // Format: "450.00"
}

/**
 * Fires when user completes the post job flow and submits the job
 * Event: dental_portal:perm_post_job:post_job_submitted
 */
export function firePermPostJobSubmitted(payload: IPermPostJobSubmittedPayload): void {
  PosthogService.getInstance().track('dental_portal:perm_post_job:post_job_submitted', {
    posting_id: payload.postingId,
    profession_type: payload.professionType,
    listing_fee: payload.listingFee,
  });
}